import { isValidQuery } from "components/hostedScrapingValidators";
import { SDEContent } from "./sdecontentTypes";

export const GoogleShoppingContent: SDEContent = {
  projectType: 'async_google_shopping',
  projectCategory: 'google',
  apiUrlFn: (apiHost: string) => {
    return `${apiHost}/structured/google/shopping/v1`;
  },
  docsSection: 'google-shopping-api',
  docsSectionTitle: 'Google Shopping API',
  docsSectionAsync: 'google-shopping-api-async',
  docsSectionAsyncTitle: 'Google Shopping API (Async)',
  inputKey: 'query',
  inputsKey: 'queries',
  validatorFunction: isValidQuery,
  newProjectEditProject: {
    inputBoxLabels: {
      listLiteralInputTitle: 'Search terms',
      listLiteralInputPlaceholder: 'Enter one search term per line.',
    },
    inputSectionLabels: {
      inputSectionTitle: "Input search term",
      inputSectionDescription: "Enter search terms in the input field or upload CSV with your search terms to begin scraping Google.",
    },
    projectContent: {
      title: 'Google shopping',
      description: 'Extract data such as reviews, product descriptions and prices from Google Shoppings websites.',
      icon: 'google',
      inputTitle: 'Query',
    },
  },
  apiPlayground: {
    inputSectionLabels: {
      inputSectionTitle: 'Input search term',
      inputSectionDescription: 'Enter Google search terms or full URLs to begin scraping Google.',
    },
    projectContent: {
      title: 'Google shopping',
      description: 'Extract data such as reviews, product descriptions and prices from Google Shoppings websites.',
      icon: 'google',
    },
    enterInputsPlaceholder: 'query',
    enterInputsMessage: 'Enter keyword for scraping',
    codeViewPlaceHolder: 'Please provide a valid search term',
    dropdownTitle: 'Google Shopping'
  }
};
